export const DELETE_COMMENT = 'DELETE_COMMENT';
export const SELECT_COMMENT = 'SELECT_COMMENT';
export const DELETE_REPLY = 'DELETE_REPLY';
export const EDIT_COMMENT = 'EDIT_COMMENT';
export const EDIT_REPLY = 'EDIT_REPLY';
